import { RadioGroup } from 'ui/RadioGroup';
import { Box } from 'ui/Box';
import { FC } from 'react';
import { RadioButton } from 'modules/RegisterModule/components/RadioButton';

export interface OptionsGroupProps {
  data: string[];
  selectedValue: string;
  onClick: (value: string) => void;
}

export const OptionsGroup: FC<OptionsGroupProps> = ({
  onClick,
  data = [],
  selectedValue,
}) => {
  return (
    <Box className="mt-9 flex w-full gap-4">
      <RadioGroup
        row
        value={selectedValue}
        className="md:flex-no-wrap flex w-full flex-col justify-center gap-[10px] md:flex-row md:gap-4"
      >
        {data.map((item) => (
          <RadioButton
            key={item}
            item={item}
            onClick={onClick}
            selectedValue={selectedValue}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};
